import { ChevronsRightLeft } from "lucide-react";
import { colorWithAlpha } from "@/lib/utils";
import type { WorkflowStage } from "@/services/workflow-stage.service";

// "In Progress" -> "IP", "Done" -> "DO".
export function stageInitials(name: string): string {
	const parts = name.trim().split(/[\s._-]+/).filter(Boolean);
	if (parts.length === 0) return "?";
	const letters =
		parts.length > 1 ? parts[0][0] + parts[1][0] : parts[0].slice(0, 2);
	return letters.toUpperCase();
}

export function CollapseStageButton({
	stage,
	onClick,
}: {
	stage: WorkflowStage;
	onClick: () => void;
}) {
	return (
		<button
			type="button"
			onClick={onClick}
			aria-label={`Collapse ${stage.name}`}
			title="Collapse column"
			className="shrink-0 rounded-md p-1 text-muted hover:bg-muted-subtle hover:text-foreground transition-colors"
		>
			<ChevronsRightLeft className="h-3.5 w-3.5" />
		</button>
	);
}

// Circle shown in place of a collapsed stage heading. Click to expand.
export function CollapsedStageCircle({
	stage,
	count,
	onExpand,
}: {
	stage: WorkflowStage;
	count: number;
	onExpand: () => void;
}) {
	return (
		<button
			type="button"
			onClick={onExpand}
			aria-label={`Expand ${stage.name} (${count} tasks)`}
			title={`${stage.name} (${count})`}
			className="relative mx-auto flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-xs font-semibold transition-transform hover:scale-105"
			style={{
				color: stage.color,
				backgroundColor: colorWithAlpha(stage.color, 0.12),
				boxShadow: `0 0 0 1px ${colorWithAlpha(stage.color, 0.35)} inset`,
			}}
		>
			{stageInitials(stage.name)}
			{count > 0 && (
				<span className="absolute -top-1 -right-1 min-w-4 h-4 px-1 rounded-full bg-surface text-[10px] leading-4 font-medium text-muted shadow-sm">
					{count}
				</span>
			)}
		</button>
	);
}
